import { HttpClient } from '@angular/common/http';
import {
  Translation,
  TranslocoLoader,
  TranslocoModule,
  provideTransloco,
} from '@jsverse/transloco';
import { Injectable, NgModule } from '@angular/core';
import { environment } from '../environments/environment';
import { Cultures } from './models/cultures.enum';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(private http: HttpClient) {
  }

  getTranslation(lang: string) {
    return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}

@NgModule({
  exports: [TranslocoModule],
  providers: [
    provideTransloco({
      config: {
        availableLangs: [
          Cultures.EnUs,
          Cultures.EnCa,
          Cultures.FrCa,
          Cultures.CaEs,
          Cultures.CsCz,
          Cultures.EsEs,
          Cultures.EsMx,
          Cultures.EnGb,
          Cultures.DeDe,
          Cultures.DeAt],
        defaultLang: Cultures.EnUs,
        reRenderOnLangChange: true,
        fallbackLang: Cultures.EnUs,
        missingHandler: { useFallbackTranslation: true },
        prodMode: environment.production,
      },
      loader: TranslocoHttpLoader
    }),
  ]
})
export class TranslocoRootModule { }
